import dayjs, { Dayjs } from 'dayjs';
import { action, computed, makeAutoObservable } from 'mobx';

export class SubstitutionStore {
  public selectedRowIndex: string = '0';
  public selectedDay: Dayjs = dayjs().startOf('day').startOf('hour');

  constructor() {
    makeAutoObservable(this, {
      setSelectedDay: action,
      dateString: computed,
    });
  }

  public get dateString(): string {
    return this.selectedDay.clone().format('YYYY-MM-DD');
  }

  public setSelectedRowIndex(index: string) {
    this.selectedRowIndex = index;
  }

  public setSelectedDay(date: Dayjs) {
    this.selectedRowIndex = '0';
    this.selectedDay = date.startOf('day').startOf('hour');
  }
}
